import { format } from "date-fns";

export function splitArray(array, maxPositions) {
  var res = [];
  for (var i = 0; i < array?.length; i = i + maxPositions) {
    res.push(array?.slice(i, i + maxPositions));
  }
  return res;
}

export function decode_utf8(s) {
  return s;
}

export function generatePdfFile(base64, myWindow) {
  let base64String = Buffer.from(base64, "hex").toString("base64");
  var element = myWindow.document.getElementById("msgLoading");
  element.innerHTML =
    "<div><iframe width='100%' height='100%' src='data:application/pdf;base64, " +
    encodeURI(base64String) +
    "'></iframe> </div>";
  myWindow.focus();
}

export function changeDataFormat(_str) {
  let _new = _str.split("-").reverse().join("-");
  return _new;
}

export function changeCurrancyFormat(_str,sampleFormatzero, isOnlyNumberString = false) {
  if (isOnlyNumberString) {
    _str = _str.replace(/\D/g, '');
  }

  const strChanged = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "CLP",
  })
    .format(Number(_str))
    .slice(4);

  if(sampleFormatzero) 
  {
    if (Number(_str) < 0) {
      return `$ -${strChanged === "0" ? "0" : strChanged.trim()}`;
    } else {
      return `$${strChanged === "0" ? "0" : strChanged}`;
    }
  } else {
    if (Number(_str) < 0) {
      return `$ -${strChanged === "0" ? "0.00" : strChanged.trim()}`;
    } else {
      return `$${strChanged === "0" ? "0.00" : strChanged}`;
    }
  }
}

export function currentData() {
  const dataObj = new Date();

  const currentDay = String(dataObj.getDate()).padStart(2, "0");
  const currentMonth = String(dataObj.getMonth() + 1).padStart(2, "0");
  const currentYear = dataObj.getFullYear();
  let currentData = currentMonth + currentDay + currentYear;
  return currentData;
}

export function dateFormatMonth(_date) {
  const arMonth = [
    "JAN",
    "FEB",
    "MAR",
    "ABR",
    "MAY",
    "JUN",
    "JUL",
    "AGO",
    "SEP",
    "OCT",
    "NOV",
    "DIC",
    "ENE",
  ];

  if (_date) {
    const _arDate = _date.split("-");
    const newDate =
      _arDate[2] + "/" + arMonth[Number(_arDate[1]) - 1] + "/" + _arDate[0];
    return newDate;
  } else {
    return "";
  }
}

export function getPathName() {
  return window.location.pathname.split("/")[
    window.location.pathname.split("/").length - 1
  ];
}

export function getSignedIdStatus() {
  try {
    // eslint-disable-next-line no-undef
    return Liferay.ThemeDisplay.isSignedIn();
  } catch (error) {
    return "";
  }
}
export function getPageLayoutType() {
  try {
    // eslint-disable-next-line no-undef
    let result = Liferay.ThemeDisplay.isPrivateLayout();
    if (result === "true") {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return "";
  }
}

export function fiilWzero(_cta_cto) {
  if (_cta_cto.length <= 7) {
    _cta_cto = "00000" + _cta_cto;
  }
  return _cta_cto;
}

export function extensionsAccepted(icon, str_ext) {
  const ext = str_ext.split(";");
  return ext.some((el) => icon.toLowerCase().endsWith(el));
}

const queryString = window.location.search;
export const urlParams = new URLSearchParams(queryString);

export function validateEmailFunc(email) {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);
}

export function validateRut(rut) {
  const newValue = rut.replace(".", "").replace(".", "").replace("-", "");
  if (newValue.length < 9) {
    return false;
  } else {
    return true;
  }
}

export function validateCell(cell) {
  if (cell && !/^[0-9]{9}$/i.test(cell)) {
    return !/^[0-9]{10}$/i.test(cell);
  }
}

export const beforeMaskedValueChange = (newState) => {
  let { value } = newState;

  const newValue = value.replace(".", "").replace(".", "").replace("-", "");

  if (newValue.length === 9) {
    value = newValue.replace(/^(\d{2})(\d{3})(\d{3})(\d{1})$/, "$1.$2.$3-$4");
  }

  return {
    ...newState,
    value,
  };
};

export const getCurrentTime = () => {
  let today = new Date();
  return today.getTime()
}

export const maxFileSize = (idFileElement, maxSizeParamKB) => {
  var uploadField = document.getElementById(idFileElement);
  var size = parseFloat(uploadField.files[0]?.size / (1024 * 1024)).toFixed(2);
  if (size > maxSizeParamKB) {
    uploadField.value = "";
    return true;
  } else {
    return false;
  }
};

export const transformId = (id) => {
  if(id){
    return id.padStart(12, '0')
  } else {
    return null
  }
}

export function removeChar(string, char) {
  return string.replace(char, '');
}

function getRutCheckDigit(T) {
  let M = 0;
  let S = 1;

  for (; T; T = Math.floor(T / 10)) {
      S = (S + T % 10 * (9 - M++ % 6)) % 11;
  }

  return S ? S - 1 : 'k';
}

export function isRutValid(completRut) {
  const cleanRut = completRut.replace(".", "").replace(".", "");

  const isFormatValid = /^[0-9]+-[0-9kK]{1}$/.test(cleanRut);

  if (!isFormatValid) {
      return false;
  }

  const tmp = cleanRut.split('-');
  let digv = tmp[1];
  const rut = tmp[0];

  if (digv === 'K') {
      digv = 'k'
  };

  let rutStatus = null;
  if(typeof getRutCheckDigit(rut) === 'string') {
    rutStatus = (getRutCheckDigit(rut) === digv);
  } else {
    rutStatus = (getRutCheckDigit(rut) === Number(digv));
  }

  return rutStatus;
}

export function beforeMaskedValueChangeRut(newState) {
  let { value } = newState;

  const newValue = value.replace(".", "").replace(".", "").replace("-", "");

  if (newValue.length === 9) {
      value = newValue.replace(/^(\d{2})(\d{3})(\d{3})(\w{1})$/, "$1.$2.$3-$4");
  }

  return {
      ...newState,
      value
  };
};


export function beforeMaskedValueChangeRutNoPoint(newState) {
  let { value } = newState;

  const newValue = value.replace(".", "").replace(".", "").replace("-", "");

  if (newValue.length === 9) {
      value = newValue.replace(/^(\d{2})(\d{3})(\d{3})(\w{1})$/, "$1$2$3-$4");
  }

  return {
      ...newState,
      value
  };
};

export function formatDate(dateString) {
  return format(new Date(dateString), 'dd-MM-yyyy');
}

export function trimLeadingZeros(string) {
  return string.replace(/^0+/, '');
}